import React from 'react'

import { ConfirmationDialog } from '@front/squirtle'
import { SuspensionPopupForm } from '@abra/elements/Suspensions'
import ShowActiveJobsPopup from '@abra/elements/Popup/ShowActiveJobs'

const Dialogs = ({ resetPassword, user_auth_id, onCallDriver }) => (
  <>
    <SuspensionPopupForm record_id={user_auth_id} />
    <ConfirmationDialog name={'confirm_reset_password'} onConfirm={resetPassword} />
    <ConfirmationDialog
      name={'confirm_call_driver'}
      onConfirm={onCallDriver}
    />
    <ShowActiveJobsPopup />
  </>
)

export default React.memo(Dialogs)
